module.exports = __webpack_public_path__ + "img/ic_play.a55b2672.svg";